import {IGlobalQuery} from 'src/app/models'

export enum EDepartmentStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export interface IDepartment {
  id: string
  code: string
  name: string
  organization_id: string
  organization_name: string
  company_id: string
  company_name: string
  cs_number: string
  cs_wa_number: string
  is_active: boolean
}

export interface IDepartmentQuery extends IGlobalQuery {
  organization_ids?: string[]
  company_ids?: string[]
  status?: keyof typeof EDepartmentStatus
}

export interface IDepartmentForm {
  code: string
  name: string
  organization_id: string
  company_id: string
  cs_number: string
  cs_wa_number: string
  is_active: boolean
}
